import { Component, EventEmitter, Output } from '@angular/core';
import {
    UntypedFormBuilder,
    UntypedFormGroup,
    Validators,
    FormsModule,
    ReactiveFormsModule
} from '@angular/forms';
import {
    ActivatedRoute,
    NavigationExtras,
    Router,
    RouterLink,
    UrlSerializer
} from '@angular/router';
import { AuthenticationService } from '@app/_services/authentication.service';
import * as _ from 'lodash';
import { ToastrService } from 'ngx-toastr';
import { TranslateHelper } from '@app/_helpers';
import { SiteService } from '@app/_services/site.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { CurrencySelectComponent } from '../../../../_components/inputs/currency-select/currency-select.component';
import { NgIf, NgStyle } from '@angular/common';
import { UserService } from '@app/_services';
import { DirectionService } from '@app/_services/direction.service';
import { IconComponent } from '@app/shared/components/icon/icon.component';
import { CountrySelectComponent } from '@app/_components/country-select/country-select.component';

@Component({
    selector: 'app-account-menu',
    templateUrl: './account-menu.component.html',
    styleUrls: ['./account-menu.component.scss'],
    providers: [TranslateHelper],
    standalone: true,
    imports: [
        NgIf,
        FormsModule,
        ReactiveFormsModule,
        RouterLink,
        CurrencySelectComponent,
        CountrySelectComponent,
        TranslateModule,
        NgStyle,
        IconComponent
    ]
})
export class AccountMenuComponent {
    @Output() closeMenu: EventEmitter<void> = new EventEmitter<void>();

    constructor(
        private fb: UntypedFormBuilder,
        private authenticationService: AuthenticationService,
        private translateHelper: TranslateHelper,
        private toastr: ToastrService,
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private userService: UserService,
        public translateService: TranslateService,
        private urlSerializer: UrlSerializer,
        private direction: DirectionService,
        public siteService: SiteService
    ) {}

    form: UntypedFormGroup = this.fb.group({
        email: [null, [Validators.required]],
        password: [null, Validators.required]
    });
    submitted = false;
    returnUrl: string;
    user;

    ngOnInit(): void {
        // const user = JSON.parse(localStorage.getItem('currentUser'));
        this.authenticationService.currentUser.subscribe((user): any => {
            if (user) this.user = user;
            else this.user = null;
        });

        this.activatedRoute.queryParams.subscribe(params => {
            this.returnUrl = params['returnUrl'] || this.router.url || '/';
        });
    }

    logout() {
        this.authenticationService.logout().subscribe(() => {
            this.form.reset();
            this.closeMenu.emit();
        });
    }
    login() {
        this.submitted = true;

        if (this.form.invalid) return;
        this.authenticationService.login(this.form.value).subscribe(
            user => {
                if (user.code == 400) {
                    this.toastr.error(
                        this.translateHelper.getTranslation('err_name_password')
                    );
                    return;
                }
                this.router.routeReuseStrategy.shouldReuseRoute = () => false;
                this.router.onSameUrlNavigation = 'reload';
                this.router.navigate([this.router.url], {
                    relativeTo: this.activatedRoute
                });
                if (!_.isEmpty(user.data)) this.user = user.data;
                else this.user = null;

                this.closeMenu.emit();
                this.toastr.success(`Welcome Back ${user.data?.name}`);
            },
            error => {
                this.toastr.error(
                    this.translateHelper.getTranslation('err_name_password')
                );
            }
        );
    }

    changeLangage(lang: string) {
        this.authenticationService.currentUser.subscribe((user: any): any => {
            if (user?.preferances?.language != lang) {
                this.userService.setLanguage({ lang: lang }).subscribe(
                    res => {
                        if (res.code == 200) {
                            this.translateService.use(lang);

                            let navigationExtras: NavigationExtras;

                            const tree = this.router.parseUrl(this.router.url);

                            let url: any = this.urlSerializer.parse(
                                this.router.url
                            );

                            let stateUrl = this.router.url.split('/');
                            let commands = [];

                            stateUrl.forEach(segment => {
                                if (
                                    segment == '' ||
                                    segment == 'en' ||
                                    segment == 'ar'
                                )
                                    return;

                                if (segment.includes('?')) {
                                    commands.push(segment.split('?')[0]);
                                    if (
                                        !_.isEmpty(url.queryParams) ||
                                        !_.isEmpty(tree.queryParams)
                                    ) {
                                        //commands.push({queryParams: url.queryParams??tree.queryParams});
                                        navigationExtras = {
                                            queryParams:
                                                url.queryParams ??
                                                tree.queryParams
                                        };
                                    }
                                } else {
                                    commands.push(segment);
                                }
                            });

                            commands.unshift('/'.concat(lang));

                            this.router.navigate(commands, navigationExtras);

                            lang == 'ar'
                                ? (this.direction.value = 'rtl')
                                : 'ltr';
                        } else {
                            //console.log("Error setting user prefered language");
                        }
                    },
                    error => {
                        //console.log("Error setting user prefered language");
                    }
                );
            }
        });
    }
}
